module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('psearch'), _vm._v(" "), _c('pswiper'), _vm._v(" "), _c('pclient'), _vm._v(" "), _c('pmove'), _vm._v(" "), _c('pclientfas'), _vm._v(" "), _c('passembly'), _vm._v(" "), _c('plist'), _vm._v(" "), _c('tohead'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-8f1fdcd4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-8f1fdcd4","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/router/router/phome.vue
// module id = 143
// module chunks = 0